import * as actionTypes from "./actionTypes";

// Load
export const mallLoadCart = () => {
  return {
    type: actionTypes.MALL_LOAD_CART
  };
};

export const mallLoadCartSuccess = data => {
  return {
    type: actionTypes.MALL_LOAD_CART_SUCCESS,
    data
  };
};

export const mallLoadCartFail = () => {
  return {
    type: actionTypes.MALL_LOAD_CART_FAIL
  };
};
// END Load

// Insert
export const mallInsertToCart = (shopID, productID, data, addType = "") => {
  return {
    type: actionTypes.MALL_INSERT_TO_CART,
    shopID,
    productID,
    data,
    addType
  };
};

export const mallInsertToCartSuccess = () => {
  return {
    type: actionTypes.MALL_INSERT_TO_CART_SUCCESS
  };
};

export const mallInsertToCartFail = () => {
  return {
    type: actionTypes.MALL_INSERT_TO_CART_FAIL
  };
};
// END Insert

// Delete
export const mallDeleteFromCart = data => {
  return {
    type: actionTypes.MALL_DELETE_FROM_CART,
    data
  };
};

export const mallDeleteFromCartSuccess = () => {
  return {
    type: actionTypes.MALL_DELETE_FROM_CART_SUCCESS
  };
};

export const mallDeleteFromCartFail = () => {
  return {
    type: actionTypes.MALL_DELETE_FROM_CART_FAIL
  };
};
// END Delete

// Update
export const mallUpdateCartItem = (shopID, cartID, data) => {
  return {
    type: actionTypes.MALL_UPDATE_CART_ITEM,
    shopID,
    cartID,
    data
  };
};

export const mallUpdateCartItemSuccess = () => {
  return {
    type: actionTypes.MALL_UPDATE_CART_ITEM_SUCCESS
  };
};

export const mallUpdateCartItemFail = () => {
  return {
    type: actionTypes.MALL_UPDATE_CART_ITEM_FAIL
  };
};
// END Update
